<style scoped lang="scss">
.switchButton {
  // display: inline-block;
  border-radius: 4px;
  // padding: auto;
  // padding: 0.3rem;
  // margin: auto;
  text-align: center;
  font-size: 0.9rem;
  // font-size: 2.8rem;
  cursor: pointer;
  transition: all ease 0.2s;
}

// .t-darkblue-b {
.switchButton_default-style {
  color: #edf5ed;
  background: #264c6a;

  // color: #D6DEE2;
  // background: #46457E;
  &.active {
    color: #2C6965;
    background: #328fd7;
    // box-shadow: 0 0 2px 2px rgba(188, 205, 200, 0.6);

    // color: #46457E;
    // background: #D6DEE2;
  }
}
</style>

<template lang="pug">
div(:class="classObject" :style="styleObject" @click="onClick")
  |{{(isActive) ? label : sleepLabel}}
</template>

<script>
export default {
  name: 'switchButton',
  props: {
    label: {type: String, default: "ON"},
    sleepLabel: {type: String, default: "OFF"},
    width: {type: Number, default: 80},
    classes: String, // temp
    isActive: {type: Boolean, default: true},
  },
  computed: {
    classObject() {
      let obj = {
        'switchButton': true,
        'active': this.isActive,
      };
      let styleClass = (this.classes) ? this.classes : 'switchButton_default-style';
      obj[styleClass] = true;
      return obj;
    },
    styleObject() {
      return {
        'width': this.width+"px",
      }
    },
  },

  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/components/sub/SwitchButton.vue